module.exports = __webpack_public_path__ + "img/revolut.67dcdcee.svg";